export default [
    {
        path: '/voucher/stock-entry',
        name: 'voucher_stock_entry',
        component: () => import('@src/voucher-stock-entry/voucher-stock-entry.vue'),
        meta: {
            title: 'Gutschein einlagern',
            role: 'ROLE_VOUCHER_STOCK_ENTRY',
        },
    },
    {
        path: '/voucher/stock-entry/config',
        name: 'voucher_stock_entry_config',
        component: () => import('@src/voucher-stock-entry/voucher-stock-entry-config.vue'),
        meta: {
            title: 'Einstellungen - Gutschein einlagern',
            role: 'ROLE_EDIT_VOUCHER_STOCK_ENTRY_CONFIG',
        },
    },
];
